import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";

const LinkNavigator:React.FC<any> = () =>{

  const handleAlert =  () => {
    alert("아직 준비중입니다.")
    window.location.href='/home'
  }
  return (
    <Container>
      <NavLink
        to="/home"
        className={({ isActive}) => {
          return isActive ? "active" : "";
        }}
      >
        <NavButtonWrapper className="btn-wrapper">
          <NavButtonFill></NavButtonFill>
          <Text>홈</Text>
        </NavButtonWrapper>
      </NavLink>
      <NavLine></NavLine>
      <NavLink
        to="/memory"
        className={({ isActive}) => {
          return isActive ? "active" : "";
        }}
      >
        <NavButtonWrapper className="btn-wrapper">
          <NavButtonFill></NavButtonFill>
          <Text>순간들</Text>
        </NavButtonWrapper>
      </NavLink>
      <NavLine></NavLine>
      {/* <NavLink
        to="/myTap"
        className={({ isActive}) => {
          // return isActive ? "active" : "";
          return isActive ? "active" : "";
        }}
      > */}
        <NavButtonWrapper 
        className="btn-wrapper"
        onClick={handleAlert}
        >
          <NavButtonFill></NavButtonFill>
          <Text>마이페이지</Text>
        </NavButtonWrapper>
      {/* </NavLink> */}
    </Container>
  )
};

export default LinkNavigator;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  
  justify-content: space-between;
  /* background-color: aqua; */
  /* min-width:100px ; */
  a {
    text-decoration: none;
    color: black;
    
  }

  a.active {
    .btn-wrapper {
      color: var(--black);
      border-bottom: solid var(--black);
    }
  }

  .btn-wrapper {
    overflow: hidden;
  }
`
const NavButtonWrapper = styled.div`
  display: flex;
  font-size: 15px;
  color: var(--grey);
  margin: 4px auto;

  * {
    margin-right: 5px;
  }

  &.btn-wrapper {
    margin-right: 50px;
  }
`
const NavButtonFill = styled.div``;

const NavLine = styled.p`
  height: 100%;
  border-left: solid var(--grey);
`;

const Text = styled.span`
  margin-bottom: 2px;
`;